import {Component, inject} from '@angular/core';
import {ActivationStart, Router, RouterOutlet} from '@angular/router';
import {AutoUnsubscribe} from './shared/classes/AutoUnsubscriber';
import {filter} from 'rxjs/operators';
import {tap} from 'rxjs';
import {environment} from '../environments/environment';
import {NavigationComponent} from './core/navigation/navigation.component';

@AutoUnsubscribe()
@Component({
    selector: 'nbd-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, NavigationComponent]
})
export class AppComponent {
  private router = inject(Router);


  directNavigation = false;

  constructor() {

    environment.appUrl = `${environment.apiUrl}/app`;
    (this as any).sub = this.router.events.pipe(
      filter((data) => data instanceof ActivationStart),
      tap((data) => {
        data = data as ActivationStart;
        this.directNavigation = data.snapshot.data['directNavigation'] ?? false;
      })
    ).subscribe();
  }
}
